var _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFullscreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.098 23.99a3.66 3.66 0 100-7.322 3.66 3.66 0 000 7.322z",
    fill: "#354767"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 13.668a2.928 2.928 0 00-2.928 2.928v11.713a2.929 2.929 0 002.928 2.928h17.57a2.929 2.929 0 002.928-2.928V16.596a2.928 2.928 0 00-2.928-2.928h-17.57zm15.81 16.105c-.664-1.86-2.577-4.392-7.025-4.392-4.447 0-6.362 2.533-7.025 4.392h-1.76a1.464 1.464 0 01-1.464-1.464V16.596a1.464 1.464 0 011.464-1.464h17.57a1.464 1.464 0 011.464 1.464v11.713a1.464 1.464 0 01-1.464 1.464h-1.76zM21.098 43.812a3.66 3.66 0 100-7.321 3.66 3.66 0 000 7.321z",
    fill: "#354767"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 33.49a2.929 2.929 0 00-2.928 2.928v11.713a2.928 2.928 0 002.928 2.929h17.57a2.928 2.928 0 002.928-2.929V36.418a2.928 2.928 0 00-2.928-2.928h-17.57zm15.81 16.105c-.664-1.859-2.577-4.392-7.025-4.392-4.447 0-6.362 2.533-7.025 4.392h-1.76a1.464 1.464 0 01-1.464-1.464V36.418a1.464 1.464 0 011.464-1.464h17.57a1.464 1.464 0 011.464 1.464v11.713a1.464 1.464 0 01-1.464 1.464h-1.76zM21.098 63.634a3.66 3.66 0 100-7.321 3.66 3.66 0 000 7.321z",
    fill: "#354767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 53.312a2.929 2.929 0 00-2.928 2.928v11.714a2.928 2.928 0 002.928 2.928h17.57a2.928 2.928 0 002.928-2.928V56.24a2.928 2.928 0 00-2.928-2.928h-17.57zm15.81 16.106c-.664-1.86-2.577-4.393-7.025-4.393-4.447 0-6.362 2.533-7.025 4.393h-1.76a1.464 1.464 0 01-1.464-1.465V56.24a1.464 1.464 0 011.464-1.464h17.57a1.464 1.464 0 011.464 1.464v11.714a1.464 1.464 0 01-1.464 1.464h-1.76z",
    fill: "#354767"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.514,
    y: 13.668,
    width: 90.101,
    height: 57.665,
    rx: 5,
    fill: "#88909F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFullscreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fullscreen.1c99b13ae686e364b4fb42e7e71cea3d.svg";